import { Link } from 'react-router-dom'
import { ExternalLink } from 'lucide-react'
import { ScrollRevealText } from './ui/scroll-reveal-text'
import { MagneticLink } from './ui/magnetic-link'

const productLinks = [
  { label: 'Quick Start', href: '/docs/overview/getting-started' },
  { label: 'Documentation', href: '/docs' },
  { label: 'Projects', href: '/projects' },
  { label: 'Skills', href: '/skills' },
  { label: 'Pricing', href: '/pricing' },
  { label: 'FAQ', href: '/faq' },
  { label: 'About', href: '/about' },
  { label: 'Feedback', href: '/feedback' },
  { label: 'Join Waitlist', href: '/waitlist' },
]

const communityLinks = [
  { label: 'GitHub', href: 'https://github.com/xvertere-org/Solarch' },
  { label: 'npm', href: 'https://www.npmjs.com/package/solarch' },
  { label: 'Issues', href: 'https://github.com/xvertere-org/Solarch/issues' },
  { label: 'Discussions', href: 'https://github.com/xvertere-org/Solarch/discussions' },
]

const docsLinks = [
  { label: 'Quick Start', href: '/docs/overview/getting-started' },
  { label: 'Auth', href: '/docs/security-auth/authentication' },
  { label: 'Database', href: '/docs/data-services/database' },
  { label: 'Realtime', href: '/docs/realtime/websocket' },
  { label: 'File Storage', href: '/docs/file-storage/upload' },
]

export default function Footer() {
  return (
    <footer className="relative w-full bg-[#0a0603] pt-32 pb-8 border-t border-theme">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-16 pb-20">
          
          {/* Left - Brand */}
          <div className="md:col-span-4 lg:col-span-3">
            <Link to="/" className="block w-auto h-8 mb-6 flex items-center gap-2.5">
              <img 
                src="/solarch-logo.svg" 
                alt="Solarch Logo" 
                className="h-full w-auto object-contain" 
              />
              <span className="font-heading font-bold text-2xl tracking-wide text-theme">Solarch</span>
            </Link>
            <p className="text-theme-secondary text-base leading-relaxed max-w-[250px]">
              A TypeScript Backend-as-a-Service in a single package.
            </p>
          </div>

          {/* Right - Navigation Grid */}
          <div className="md:col-span-8 lg:col-span-8 lg:col-start-5 grid grid-cols-2 sm:grid-cols-3 gap-12 lg:gap-16">
            {/* Product */}
            <div className="flex flex-col gap-6">
              <h4 className="font-heading text-sm font-semibold uppercase tracking-[0.2em] text-theme-muted">
                Product
              </h4>
              <ul className="flex flex-col gap-4">
                {productLinks.map((link) => (
                  <li key={link.label}>
                    <MagneticLink to={link.href} className="text-[17px] text-theme-secondary hover:text-theme">
                      {link.label}
                    </MagneticLink>
                  </li>
                ))}
              </ul>
            </div>

            {/* Docs */}
            <div className="flex flex-col gap-6">
              <h4 className="font-heading text-sm font-semibold uppercase tracking-[0.2em] text-theme-muted">
                Docs
              </h4>
              <ul className="flex flex-col gap-4">
                {docsLinks.map((link) => (
                  <li key={link.label}>
                    <MagneticLink to={link.href} className="text-[17px] text-theme-secondary hover:text-theme">
                      {link.label}
                    </MagneticLink>
                  </li>
                ))}
              </ul>
            </div>

            {/* Community */}
            <div className="flex flex-col gap-6">
              <h4 className="font-heading text-sm font-semibold uppercase tracking-[0.2em] text-theme-muted">
                Community
              </h4>
              <ul className="flex flex-col gap-4">
                {communityLinks.map((link) => (
                  <li key={link.label}>
                    <MagneticLink href={link.href} className="text-[17px] text-theme-secondary hover:text-theme">
                      <span className="inline-flex items-center gap-1.5">
                        {link.label}
                        <ExternalLink className="h-3.5 w-3.5 opacity-50" />
                      </span>
                    </MagneticLink>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

      </div>

      {/* Big Reveal Text Area - Edge to Edge */}
      <div className="w-full overflow-visible">
        <ScrollRevealText text="SOLARCH" />
      </div>

      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        {/* Bottom Bar */}
        <div className="flex flex-col-reverse md:flex-row items-center justify-between gap-6 pt-6 text-sm text-theme-muted">
          <div>
            &copy; {new Date().getFullYear()} Solarch.
          </div>
          <div className="flex items-center gap-6">
            <Link to="/privacy" className="transition-colors hover:text-theme">Privacy Policy</Link>
            <a href="https://github.com/xvertere-org/Solarch/blob/main/LICENSE" target="_blank" rel="noreferrer" className="transition-colors hover:text-theme">Apache-2.0 License</a>
          </div>
        </div>
      </div>
    </footer>
  )
}
